import React from 'react';
import { Menu, MenuButton, MenuItem, MenuItems, Transition } from '@headlessui/react';
import { AdjustmentsHorizontalIcon } from '@heroicons/react/20/solid';
import clsx from 'clsx';

interface IProps {
    onChange: (values: string) => void;
    selectedValue: string;
    options: string[];
    label: string;
}

export default function StatusFilter(props: IProps) {
    const [menuOpen, setMenuOpen] = React.useState(false);

    return (
        <Menu as='div' className='relative w-full h-full'>
            <MenuButton
                onClick={() => setMenuOpen(!menuOpen)}
                className='items-center text-gray-900 hover:bg-gray-200 w-full h-full cursor-pointer'
            >
                <span className='inline-flex items-center'>
                    {props.label}
                    <AdjustmentsHorizontalIcon className='ml-2 h-4 w-4' />
                </span>
            </MenuButton>

            <Transition
                as={React.Fragment}
                enter='transition ease-out duration-100'
                enterFrom='transform opacity-0 scale-95'
                enterTo='transform opacity-100 scale-100'
                leave='transition ease-in duration-75'
                leaveFrom='transform opacity-100 scale-100'
                leaveTo='transform opacity-0 scale-95'
            >
                <MenuItems className='absolute overflow-hidden left-0 z-10 mt-2 w-32 text-left origin-top-right rounded-md bg-white shadow-lg border border-gray-300 focus:outline-none'>
                    {props.options.map((option) => (
                        <MenuItem
                            key={option}
                            as='div'
                            onClick={() => props.onChange(option)}
                            className={clsx(
                                'block px-3 py-2 text-sm font-medium text-gray-900 capitalize select-none',
                                {
                                    'bg-blue-200': props.selectedValue === option,
                                    'hover:bg-gray-200 cursor-pointer': props.selectedValue !== option,
                                },
                            )}
                        >
                            {option === 'in_progress' ? 'Pending' : option.replaceAll('_', ' ')}
                        </MenuItem>
                    ))}
                </MenuItems>
            </Transition>
        </Menu>
    );
}
